import angular from 'angular';

import orderRenewalService from '../../services/orderrenewal.service';

import orderRenewalController from './orderRenewal.controller';
import orderRenewalModalController from './orderRenewalModal.controller';
//import orderRenewalListController from './orderRenewalList.controller';

export default angular.module('components.orderenewal', [ orderRenewalService ])
    .component('orderRenewal', {
        template: require('./orderRenewal.pug')(),
        bindings: {
            text: '@',
            docid: '<',
            barcode: '<',
            patronymicname: '@',
            firstname: '@',
            surename: '@',
            sigla: '@',
            onDone: '&'
        },
        controller: orderRenewalController
    })
    .component('orderRenewalModal', {
        template: require('./orderRenewalModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: orderRenewalModalController
    })
    /*
    .component('orderRenewalList', {
        template: require('./orderRenewalList.pug')(),
        bindings: {
        }, 
        controller: orderRenewalListController
    })
    */
    .value('OrderRenewalConfig', {
        catalogid: 1
    })
    .name; 
